import WsService from "./WsService";
import RawWsService from "./RawWsService";
import Beneficiary from "../domain/Beneficiary";

const ENDPOINT_BASE = "/transactions/beneficiary";

export default class BeneficiaryService {

    static createBeneficiaryWithRequiredFields(beneficiaryCreationRequest) {

        return WsService.post(ENDPOINT_BASE, beneficiaryCreationRequest, 201).then(
            response => {
                return response;
            },
            response => {
                return response;
            }
        )
    }

    static retrieveBeneficiariesByRegistrationId(registrationId, search, pageSize) {

        let endpoint = ENDPOINT_BASE + "?registration-id=" + registrationId + "&search=" + search;

        let headers = {
            'x-page-size': pageSize,
            'x-sort-order': "DESC",
            'x-sort-by' : "id"
        };

        return RawWsService.getWithHeaders(endpoint, {}, 200, headers).then(
            response => {
                let array = [];
                response.body.forEach(jsonBeneficiary => {
                    array.push(new Beneficiary(jsonBeneficiary));
                });
                return {"headers": response.headers, "body": array};
            },
            response => {
                return response;
            });
    }
    static retrieve(beneficiaryId) {

        let endpoint = ENDPOINT_BASE + "/" + beneficiaryId;

        return WsService.get(endpoint, {}, 200).then(
            response => {
                return new Beneficiary(response)
            },
            response => {
                return response;
            });
    }

    static updateBeneficiary(beneficiaryId, beneficiary) {

        let endpoint = ENDPOINT_BASE + "/" + beneficiaryId;
        let jsonBeneficiary = Beneficiary.toJson(beneficiary);

        return WsService.put(endpoint, jsonBeneficiary, 200).then(
            response => {
                return response;
            },
            response => {
                return response;
            }
        )
    }

    static deleteBeneficiary(id) {

        let endpoint = ENDPOINT_BASE + "/" + id;

        return WsService.del(endpoint, {}, 204).then(
            response => {
                return "success";
            },
            response => {
                return response
            }
        )
    }


}